﻿import * as moment from 'moment';

export class Patient {
    id: string;
    firstName: string;
    lastName: string;
    birthday: string;
    idAvatar: number;
    archived: boolean;
    userId: string;

    constructor(json: any) {
        this.id = json.id;
        this.firstName = json.firstName;
        this.lastName = json.lastName;
        this.birthday = json.birthday;
        this.idAvatar = json.idAvatar;
        this.archived = json.archived;
        this.userId = json.userId;
    }

    public getAge(): number {
        const birthday = moment(this.birthday, 'YYYY-MM-DD');
        return moment().diff(birthday, 'years');
    }
}
